import styles from './identificationQRCode.module.css';
import { Typography } from '@pvh-components/typography';
import { QRCodeSVG } from 'qrcode.react';

export interface IdentificationQRCodeProps {
  email: string;
  title: string;
  tagline: string;
}

const IdentificationQRCode = ({
  email,
  title,
  tagline,
}: IdentificationQRCodeProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.column1}>
        <QRCodeSVG className={styles.qrcode} value={email} />
      </div>
      <div className={styles.column2}>
        <Typography variant="h2">{title}</Typography>
        <Typography variant="bodyLarge">{tagline}</Typography>
      </div>
    </div>
  );
};

export default IdentificationQRCode;
